/*
hc-oauth-module.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/services/hc-oauth/hc-oauth-module',['angular', 'jquery', 'uiRouter'], function (angular, $) {
    'use strict';

    /**
     * Login config for 'secure' state
     */
    var module = angular.module('hcOauthModule', ['ui.router']);

    var clearSessionStorageEntries = function ($window) {
        var nextScreen = $window.sessionStorage.getItem('next-screen');
        $window.sessionStorage.clear();
        nextScreen && $window.sessionStorage.setItem('next-screen', nextScreen);
    };

    module.service('SecuredViewService', ['$q', '$location', '$window', 'LoginService', function ($q, $location, $window, LoginService) {
        this.testSecureViewAccess = function () {
            var q = $q.defer();

            // Retrieves token from session storage
            var token = $window.sessionStorage.getItem('cIdToken');

            // If we have the token, resolve
            if (token) {
                q.resolve(token);
            }
            // Otherwise, redirect to the login page
            else {
                $window.sessionStorage.setItem('next-screen', JSON.stringify($location.path()));
                $window.location = LoginService.getUrl();
            }

            return q.promise;
        };
    }]);

    module.config(['$httpProvider', '$stateProvider', function ($httpProvider, $stateProvider) {
        $stateProvider
            .state('secure', {
                template: '<ui-view/>',
                abstract: true,
                resolve: {
                    token: ['SecuredViewService', function (securedViewService) {
                        return securedViewService.testSecureViewAccess();
                    }]
                }
            });

        /**
         * Retrieves the security token from sessionStorage and adds it to the $http request header
         */
        $httpProvider.interceptors.push(['$window', '$q', function ($window, $q) {
            return {
                // Add Authorization header with each request
                'request': function (config) {
                    if ($window.sessionStorage.getItem('cIdToken')) {
                        var token = $window.sessionStorage.getItem('cIdToken');
                        if (token) {
                            config.headers.Authorization = 'Bearer ' + token;
                        }
                    }
                    return config;
                },

                responseError: function (rejection) {
                    if (rejection && rejection.status === 401) {
                        var hasToken = $window.sessionStorage.getItem('cIdToken');
                        clearSessionStorageEntries($window);
                        localStorage.clear();
                        $window.location = hasToken ? '/login?message=440' : '/login';
                    }
                    return $q.reject(rejection);
                }
            };
        }]);
    }]);

    /**
     * Multi-tab - Copy token into session storage if the session storage is empty.
     */
    module.run(['$window', function ($window) {
        var addAuthorizationHeader = function (xhr) {
            var token = $window.sessionStorage.getItem('cIdToken');
            if(token) {
                xhr.setRequestHeader('Authorization','Bearer ' + token);
            }
        };

        var addCacheControl = function (xhr, settings) {
            var isGETRequest = !settings.type || settings.type.toUpperCase() === 'GET';
            if(isGETRequest && settings.cache !== true) {
                xhr.setRequestHeader('Cache-Control', 'no-cache, no-store, must-revalidate');
                xhr.setRequestHeader('Pragma', 'no-cache');
                xhr.setRequestHeader('Expires', '0');
            }
        };

        if ($window.sessionStorage.getItem('cIdToken')) {
            $.ajaxSetup({
                beforeSend: function (xhr, settings) {
                    addAuthorizationHeader(xhr);
                    addCacheControl(xhr, settings);
                }
            });

            $(document).ajaxComplete(function (event, xhr) {
                // Detect invalid session errors
                if (xhr && xhr.status === 401) {
                    var hasToken = $window.sessionStorage.getItem('cIdToken');
                    clearSessionStorageEntries($window);
                    localStorage.clear();
                    $window.location = hasToken ? '/login?message=440' : '/login';
                }
            });
        }
    }]);

    module.run(['$rootScope', '$location', 'LoginService', '$timeout', function ($rootScope, $location, LoginService, $timeout) {
        function logout() {
            $timeout(function () {
                $location.path(LoginService.getUrl() || '/');
            }, 100);
        }

        $rootScope.$on('oauth:logout', logout);
        $rootScope.$on('oauth:expired', logout);
    }]);

    /**
     * Login service to setup a login path
     */
    module.factory('LoginService', function () {
        var service = {};
        var url;

        /**
         * Sets login page url
         * @param loginUrl
         */
        service.setUrl = function (loginUrl) {
            url = loginUrl;
        };

        /**
         * Returns login page url
         * @returns {*}
         */
        service.getUrl = function () {
            return (url || '/login');
        };

        return service;
    });

    return module;
});

